var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.page.cnt > 0
      ? _c(
          "div",
          { staticClass: "pagination catalog__pagination" },
          [
            _c("span", { staticClass: "pagination-header xs-hide" }, [
              _vm._v("Страницы: "),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "pagination__item",
                class: { disabled: _vm.pages.current === 1 },
                attrs: { href: "#1", disabled: _vm.pages.current === 1 },
                on: {
                  click: function ($event) {
                    return _vm.toPage(1)
                  },
                },
              },
              [
                _c("span", {
                  staticClass: "pagination__item-icon icon icon-arrow-left",
                }),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.pageCount, function (n) {
              return [
                n != _vm.pageCenter
                  ? [
                      _vm.pages.current - _vm.pageCenter + n > 0 &&
                      _vm.pages.current - _vm.pageCenter + n <= _vm.pages.last
                        ? _c(
                            "a",
                            {
                              staticClass: "pagination__item",
                              attrs: {
                                href:
                                  "#" +
                                  (_vm.pages.current - _vm.pageCenter + n),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toPage(
                                    _vm.pages.current - _vm.pageCenter + n
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.pages.current - _vm.pageCenter + n)
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : [
                      _c("span", { staticClass: "pagination-monitor" }, [
                        _vm._v(_vm._s(_vm.pages.current)),
                      ]),
                    ],
              ]
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "pagination__item",
                class: { disabled: _vm.pages.current == _vm.pages.last },
                attrs: {
                  href: "#" + _vm.pages.last,
                  disabled: _vm.pages.current == _vm.pages.last,
                },
                on: {
                  click: function ($event) {
                    return _vm.toPage(_vm.pages.last)
                  },
                },
              },
              [
                _c("span", {
                  staticClass: "pagination__item-icon icon icon-arrow-right",
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "pagination_other" }, [
              _c("span", {
                staticClass: "pagination__item-icon icon icon-arrow-bottom",
              }),
              _vm._v(" "),
              _c("div", { staticClass: "pagination_menu" }, [
                _c("input", {
                  staticClass: "pagination-monitor pagination__input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.pages.current + 1 },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  {},
                  _vm._l(_vm.pages.last, function (pageItem) {
                    return _c("li", [
                      _c(
                        "a",
                        {
                          attrs: { href: "#" + pageItem },
                          on: {
                            click: function ($event) {
                              return _vm.toPage(pageItem)
                            },
                          },
                        },
                        [
                          pageItem == _vm.pages.current
                            ? _c("span", { staticClass: "active" }, [
                                _vm._v(_vm._s(pageItem)),
                              ])
                            : _c("span", [_vm._v(_vm._s(pageItem))]),
                        ]
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "loader-mini",
              class: { active: _vm.isLoading },
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }